import { StyledTab, StyledTabList, StyledTabPanel, StyledTabs } from './theme'

export { StyledTab as Tab, StyledTabList as TabList, StyledTabPanel as TabPanel, StyledTabs as Tabs }



// WEBPACK FOOTER //
// ./src/components/Tabs/index.js